<div class="td-wb-checkbox-group"
     [class.td-wb-checkbox-group--vertical]="direction() === 'vertical'">
  <ng-content/>
</div>
